import { Title } from "@justhome/react-ui";
import useLinks from "@lib/hooks/useLinks";
import EmbedLayout from "@modules/application/components/EmbedLayout";
import MaximumBudgetCard from "@modules/application/components/MaximumBudgetCard";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import { BudgetCheckFormValues } from "@modules/application/lib/budgetCheck/types";
import { useRouter } from "next/router";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FormStepComponent } from "../FormSteps/FormSteps";

const EmbeddedBudgetFinalScreen: FC<
  FormStepComponent<BudgetCheckFormValues>
> = ({ currentStepNumber, numberOfSteps }) => {
  const { t } = useTranslation("budget-check");
  const router = useRouter();
  const {
    state: { maximumBudget },
  } = useApplicationContext();
  const { getApplicationProcessLink } = useLinks();
  useEffect(() => {
    if (!maximumBudget) {
      router.push(getApplicationProcessLink("budget-check"));
    }
  }, [maximumBudget, getApplicationProcessLink, router]);

  if (!maximumBudget) {
    return null;
  }

  return (
    <EmbedLayout>
      <EmbedLayout.Body
        showProgress={false}
        currentStepNumber={currentStepNumber}
        numberOfSteps={numberOfSteps}
        state={currentStepNumber}
      >
        <div className="grow flex flex-col items-center">
          <div className="flex flex-col">
            <Title as="h1" className="text-h1 mb-3s text-balance">
              {t("result_title")}
            </Title>
            <MaximumBudgetCard
              maximumBudget={maximumBudget}
              className="mb-3s"
            />
            <p className="text-body-2">{t("result_note")}</p>
          </div>
        </div>
      </EmbedLayout.Body>
    </EmbedLayout>
  );
};

export default EmbeddedBudgetFinalScreen;
